import React, { useEffect, useState } from 'react'
import MySelect from '../../UI/form/MySelect'

const PdvSelectMain = ({ required, setValidate, setValueForm, forciblyValue }) => {

  	const [value, setValue] = useState(forciblyValue)
  	const [validSelect, setValidSelect] = useState(false)
	const [pdvs, setPdvs] = useState([
		{
			id: 'withPdv',
			name: 'з ПДВ'
		},
		{
			id: 'withoutPdv',
			name: 'Без ПДВ'
		},
	])

	useEffect(() => {
		valid()
	}, [required, value])

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
				setValidSelect(true)
			} else {
				setValidate(false)
				setValidSelect(false)
			}
		} else {
			setValidate(true)
			setValidSelect(true)
		}
	}

  return (
    <MySelect
        value={value}
        label="ПДВ"
        labelId="select__pdv-label"
        id='select__pdv'
        onChange = {e => {
			setValueForm(e)
            setValue(e)
			// setEvent({...event, categoryId: e})
		}}
        nameField='ПДВ'
        // sx={{width: '200px'}}
        options={
			pdvs && pdvs.length > 0 ? 
				pdvs.map(pdv => {
            		return {id: pdv.id, name: pdv.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default PdvSelectMain